import { render, staticRenderFns } from "./CmgPasswordResetRequestForm.vue?vue&type=template&id=08a1fc56&scoped=true&lang=pug&"
import script from "./cmg-password-reset-request-form.ts?vue&type=script&lang=ts&"
export * from "./cmg-password-reset-request-form.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPasswordResetRequestForm.vue?vue&type=style&index=0&id=08a1fc56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1fc56",
  null
  
)

export default component.exports